export const SUPER_ADMIN_PERMISSION = 'SUPER_ADMIN/SUPPORT';
export const SCHOOL_ADMIN_PERMISSION = 'ADMIN';

function toInt(value) {
  const parsed = Number(value);
  return Number.isInteger(parsed) ? parsed : null;
}

function isDevMockAdmin(user) {
  return Boolean(user)
    && !user.permission_level
    && !user.school_id
    && !user.type
    && !user.school_ids;
}

export function isSuperAdminUser(user) {
  return Boolean(user)
    && (user.permission_level === SUPER_ADMIN_PERMISSION || isDevMockAdmin(user));
}

export function getSchoolAdminSchoolId(user) {
  if (!user || user.permission_level !== SCHOOL_ADMIN_PERMISSION) {
    return null;
  }

  return toInt(user.school_id);
}

export function isSchoolAdminUser(user) {
  return Boolean(getSchoolAdminSchoolId(user));
}

export function isAdminPortalUser(user) {
  return isSuperAdminUser(user) || isSchoolAdminUser(user);
}

export function getAdminPortalAccessError(user) {
  if (isAdminPortalUser(user)) {
    return '';
  }

  if (user?.permission_level === SCHOOL_ADMIN_PERMISSION) {
    return 'This school administrator account is missing a school assignment.';
  }

  return 'This portal is only available to super admins and school administrators.';
}
